import type { ClubMessageData } from '@ps/web-shared-api-types/v1-preview/SwHomeGames';
import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { FormattedDate } from 'react-intl';

import getDateDetails from '../../Wall/utils/getDateDetails';
import AnnouncementIcon from '../assets/Announcement.svg';

import { TXTMOB_Yesterday } from './AnnouncementInfo.messages.json';
import styles from './Announcementinfo.scss';

export interface FormFields {
  announcement: string;
}

interface Announcement {
  announcementState: ClubMessageData & { created?: string };
  controls?: JSX.Element | JSX.Element[] | null;
  sideControls?: JSX.Element | JSX.Element[] | null;
}

const AnnouncementInfo: React.FC<Announcement> = ({
  announcementState,
  sideControls = null,
  controls = null
}) => {
  const { isSameYear, isSameDay, isSameMonth, isYesterday } = getDateDetails(
    announcementState.created
  );
  const hideDayAndMonth = (isSameYear && isSameMonth && isSameDay) || isYesterday;

  return (
    <>
      <AnnouncementIcon width={42} />
      <div className={styles.announcementContainer}>
        <div
          data-testid="announcements-info"
          className={classNames({ [styles.announcementInfo]: !!controls })}
        >
          <div className={styles.date}>
            <span className={styles.username}>{announcementState.userId}</span>
            &nbsp;
            {announcementState.created && (
              <span>
                {isYesterday && (
                  <span>
                    <Translation {...TXTMOB_Yesterday} />
                    ,&nbsp;
                  </span>
                )}
                <FormattedDate
                  value={announcementState.created}
                  day={hideDayAndMonth ? undefined : '2-digit'}
                  month={hideDayAndMonth ? undefined : 'short'}
                  year={isSameYear ? undefined : 'numeric'}
                  hour="2-digit"
                  minute="numeric"
                  hour12={false}
                />
              </span>
            )}
          </div>
          {sideControls}
        </div>
        <div className={styles.announcement}>{announcementState.content}</div>
        {controls}
      </div>
    </>
  );
};

export default AnnouncementInfo;
